import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { useAuth, homeFor } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function FirstAccess() {
  const { user, reload, logout } = useAuth();
  const nav = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token");
  const [info, setInfo] = useState(null);
  const [bad, setBad] = useState(null);
  const [f, setF] = useState({ new_password: "", confirm_password: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (token) api.get(`/auth/activate/${token}`).then((r) => setInfo(r.data)).catch((e) => setBad(errMsg(e))); }, [token]);
  const who = token ? info : user;
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      if (token) {
        const { data } = await api.post(`/auth/activate/${token}`, f);
        toast.success("Senha criada! Agora entre com seu e-mail e a nova senha.");
        nav(`/login?email=${encodeURIComponent(data.email)}`, { replace: true });
      } else {
        const { data } = await api.post("/auth/first-password", f); await reload(); toast.success("Senha definida. Bem-vindo à DPdigi!"); nav(homeFor(data), { replace: true });
      }
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6" data-testid="first-access-page">
      <form onSubmit={submit} className="w-full max-w-md bg-white border rounded-2xl p-8 space-y-5 shadow-sm">
        <span className="h-11 w-11 rounded-xl bg-indigo-50 text-indigo-700 flex items-center justify-center"><KeyRound className="h-5 w-5" /></span>
        {bad ? <div className="space-y-3" data-testid="first-access-invalid"><h1 className="font-display text-2xl font-semibold">Link inválido</h1><p className="text-sm text-slate-600">{bad}</p>
          <Button type="button" className="w-full" onClick={() => nav("/login")}>Ir para o login</Button></div> : <>
          <div><h1 className="font-display text-2xl font-semibold">Crie sua nova senha</h1>
            <p className="text-sm text-slate-500 mt-1">{who?.name ? `Olá, ${who.name.split(" ")[0]}. ` : ""}{info?.company ? `Acesso da empresa ${info.company}. ` : ""}Por segurança, defina uma senha pessoal para continuar. Use ao menos 8 caracteres, com letras e números.</p></div>
          <input type="text" name="username" autoComplete="username" value={who?.email || ""} readOnly hidden />
          {who?.email && <div className="text-sm">Usuário: <b data-testid="first-access-email">{who.email}</b></div>}
          <div><Label className="text-xs">Nova senha</Label><Input type="password" autoComplete="new-password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} className="mt-1" data-testid="first-access-new" required /></div>
          <div><Label className="text-xs">Confirmar nova senha</Label><Input type="password" autoComplete="new-password" value={f.confirm_password} onChange={(e) => setF({ ...f, confirm_password: e.target.value })} className="mt-1" data-testid="first-access-confirm" required /></div>
          <Button type="submit" disabled={busy || (token && !info)} className="w-full font-bold" data-testid="first-access-submit">{busy ? "Salvando..." : "DEFINIR SENHA E CONTINUAR"}</Button>
          {!token && <button type="button" onClick={async () => { await logout(); nav("/login"); }} className="w-full text-xs text-slate-500 hover:text-slate-800" data-testid="first-access-logout">Sair</button>}</>}
      </form>
    </div>);
}
